export default __webpack_public_path__ + "static/media/notes.4a922dd9.png";